import React from 'react'
import MaterialSymbol from '../material-symbol'

const CheckCircleOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="check_circle_outline" {...props} />
))

CheckCircleOutline.displayName = 'CheckCircleOutline'

export default CheckCircleOutline
